import { createTheme } from '@mui/material/styles';
import createPalette from '@mui/material/styles/createPalette';
import createTypography from '@mui/material/styles/createTypography';

export const font = "'Source Sans Pro', sans-serif";

export const palette = createPalette({
  text: {
    primary: '#3C3C3C',
    secondary: '#6F6F6F',
  },
  primary: {
    main: '#f17435',
    light: '#ffa563',
    dark: '#b84501',
    contrastText: '#fff',
  },
  secondary: {
    main: '#19857b',
  },
  error: { main: '#f44336', light: '#e57373' },
  warning: { main: '#ffa726 ', light: '#ffb74d' },
  success: { main: '#66bb6a', light: '#81c784' },
  background: { default: '#fff', paper: '#F5F5F5' },
});

export const typography = createTypography(palette, {
  fontFamily: font,
  h1: {
    font: 'normal normal bold 25px/32px Source Sans Pro',
    textTransform: 'none',
  },
  h2: {
    font: 'normal normal bold 21px/27px Source Sans Pro',
    textTransform: 'none',
  },
  h3: {
    font: 'normal normal bold 18px/26px Source Sans Pro',
    textTransform: 'none',
  },
  h4: {
    font: 'normal normal normal 18px/26px Source Sans Pro',
    textTransform: 'none',
  },
  h5: {
    font: 'normal normal bold 25px/32px Source Sans Pro',
    textTransform: 'none',
  },
  body1: {
    font: 'normal normal normal 18px/26px Source Sans Pro',
  },
  body2: {
    font: 'normal normal normal 18px/26px Source Sans Pro',
    color: palette.text.secondary,
  },
  button: {
    font: `normal normal bold 18px/23px Source Sans Pro`,
    textTransform: 'none',
  },
  subtitle2: {
    // font: "normal normal bold 35px/30px Dancing Script",
    fontFamily: "'Dancing Script', cursive",
    fontWeight: '600',
    fontSize: '35px',
  },
});

// A custom theme for this app
const theme = createTheme({
  palette,
  typography,
});

export default theme;
